var map = {
	"./about/desktop/bg-quality.png": "c857",
	"./about/desktop/illustration-australia.svg": "a3fd",
	"./about/desktop/illustration-canada.svg": "19f6",
	"./about/desktop/illustration-uk.svg": "cd24",
	"./about/desktop/image-commitment.jpg": "c324",
	"./about/desktop/image-hero-whitecup.jpg": "20b4",
	"./about/desktop/image-quality.jpg": "47b8",
	"./about/mobile/bg-quality.png": "86fe",
	"./about/mobile/image-commitment.jpg": "7d3e",
	"./about/mobile/image-hero-whitecup.jpg": "8b59",
	"./about/mobile/image-quality.jpg": "74f8",
	"./about/tablet/bg-quality.png": "ac5e",
	"./about/tablet/image-commitment.jpg": "b9b7",
	"./about/tablet/image-hero-whitecup.jpg": "70ec",
	"./about/tablet/image-quality.jpg": "e18e",
	"./favicon-32x32.png": "f245",
	"./home/desktop/icon-coffee-bean.svg": "2828",
	"./home/desktop/icon-gift.svg": "a654",
	"./home/desktop/icon-truck.svg": "59cb",
	"./home/desktop/image-danche.png": "7df4",
	"./home/desktop/image-gran-espresso.png": "63ce",
	"./home/desktop/image-hero-coffeepress.jpg": "5078",
	"./home/desktop/image-piccollo.png": "8d32",
	"./home/desktop/image-planalto.png": "a05b",
	"./home/mobile/image-hero-coffeepress.jpg": "f615",
	"./home/tablet/image-hero-coffeepress.jpg": "2e3c",
	"./plan/desktop/bg-modal-top.png": "2e9c",
	"./plan/desktop/bg-order-summary.png": "cb83",
	"./plan/desktop/bg-steps.png": "6f09",
	"./plan/desktop/icon-arrow.svg": "025c",
	"./plan/desktop/image-hero-blackcup.jpg": "973c",
	"./plan/mobile/bg-order-summary.png": "4af5",
	"./plan/mobile/bg-steps.png": "cae8",
	"./plan/mobile/image-hero-blackcup.jpg": "9409",
	"./plan/tablet/bg-steps.png": "a399",
	"./plan/tablet/image-hero-blackcup.jpg": "17a6",
	"./shared/desktop/icon-facebook.svg": "414a",
	"./shared/desktop/icon-instagram.svg": "51aa",
	"./shared/desktop/icon-twitter.svg": "cf3d",
	"./shared/desktop/logo-footer.svg": "bbc7",
	"./shared/desktop/logo.svg": "8e74",
	"./shared/mobile/icon-close.svg": "955a",
	"./shared/mobile/icon-hamburger.svg": "bc90"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";